<script>
import FormElement from '@wielink-application/shared/vue/components/form/input-only/input.vue'

export default FormElement;
</script>